export default class LatestContinuousIdlingTimeModel {
  constructor(item) {
    this.id = item?.ID;
    this.vehiclename = item?.vehiclename;
    this.PlateNumber = item?.PlateNumber;
    this.Drivername = item?.Drivername;
    this.LatestIdlingTime = item?.LatestIdlingTime;
  }
}